import Decrease from '@/screens/decreases'
import DecreaseCapture from '@/screens/decreases/Decrease'
import Decreases from '@/screens/decreases/List'

import auth from './middleware/auth'

import store from '@/store'

const routes = [
  {
    path: '/decreases',
    name: 'Decrease',
    component: {
      ...Decrease,
      beforeRouteUpdate (to, from, next) {
        if (to.name === 'Decrease') {
          const routes = {
            manager: 'Decreases',
            chef: 'Decreases',
            stockmanager: 'Decreases',
            buyer: 'Decreases'
          }
          const role = store.state.login.role
          return next({ name: routes[role] })
        }
        return next()
      },
      beforeRouteEnter (to, from, next) {
        if (to.name === 'Decrease') {
          const routes = {
            manager: 'Decreases',
            chef: 'Decreases',
            stockmanager: 'Decreases',
            buyer: 'Decreases'
          }
          const role = store.state.login.role
          return next({ name: routes[role] })
        }
        return next()
      }
    },
    meta: { requireAuth: true },
    children: [
      {
        path: 'list',
        name: 'Decreases',
        component: Decreases,
        meta: {
          requireAuth: true,
          permissions: ['manager', 'buyer'],
          middleware: { auth }
        }
      },
      {
        path: 'capture',
        name: 'DecreaseCapture',
        component: DecreaseCapture,
        meta: {
          requireAuth: true,
          permissions: ['manager', 'buyer'],
          middleware: { auth }
        }
      }
    ]
  }
]

export default routes
